import { useState } from 'react';

export const useLightForm = (initialFields = {}) => {
  const [fieldsState, setFieldsState] = useState(initialFields);
  const [errorsState, setErrorsState] = useState([]);
  const [loadingState, setLoadingState] = useState(false);

  const getFieldValue = fieldName => fieldsState[fieldName];

  const setFieldValue = (fieldName, value) => {
    setFieldsState({ ...fieldsState, ...{ [fieldName]: value } });
    setErrorsState(errorsState.filter(items => items.field !== fieldName));
  };

  const setFieldValues = values => {
    setFieldsState({ ...fieldsState, ...values });
    setErrorsState(
      errorsState.filter(items => !Object.keys(values).includes(items.field))
    );
  };

  const resetFields = () => setFieldsState(initialFields);

  const setErrors = errors => {
    setErrorsState(errors);
  };

  const clearErrors = () => {
    setErrorsState([]);
  };

  const hasFieldError = fieldName =>
    !!errorsState.find(item => item.field === fieldName);

  const getFirstFieldError = fieldName => {
    const find = errorsState.find(item => item.field === fieldName);
    return find ? find.message : null;
  };

  const setLoading = bool => {
    setLoadingState(bool);
  };

  return {
    fields: fieldsState,
    getFieldValue,
    setFieldValue,
    setFieldValues,
    setLoading,
    resetFields,
    setErrors,
    clearErrors,
    hasFieldError,
    getFirstFieldError,
    isLoading: loadingState
  };
};

export default useLightForm;



// WEBPACK FOOTER //
// ./src/utils/hooks/useLightForm.js